// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import VueMaterial from 'vue-material'
import 'vue-material/dist/vue-material.min.css'
import 'vue-material/dist/theme/default.css' // This line here

import 'flexboxgrid/dist/flexboxgrid.min.css'
import './assets/app.css'
import Notifications from 'vue-notification'
import VeeValidate from 'vee-validate'
import VueUpload from '@websanova/vue-upload'

import VueIntro from 'vue-introjs'
import 'intro.js/introjs.css'
import './assets/pricingstyle.css'
import Chartkick from 'vue-chartkick'
import Chart from 'chart.js'
import 'chartjs-plugin-labels'

const configVeeValidate = {
  fieldsBagName: 'fieldsss'
}

Vue.use(Chartkick.use(Chart))

Vue.use(VueIntro)

Vue.use(VeeValidate, configVeeValidate)
Vue.use(Notifications)
Vue.use(VueMaterial)

Vue.use(VueUpload)

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js